import { createFileRoute } from '@tanstack/react-router'
import { BuyerCdrsPage } from '@/features/buyer-panel/pages/buyer-cdrs-page'

export const Route = createFileRoute('/_authenticated/buyer-panel/cdrs')({
  component: BuyerCdrsPage,
})
